import 'bootstrap/dist/css/bootstrap.min.css'
import { Container, Row, Col, Form } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { templateList } from '../Misc/Templates';
import { authFetch } from '../Auth/apiClient'
import { useMsal } from '@azure/msal-react';

function makePageTemplates(pages, template) {
    let pageTemplates = {}
    for (let i = 1; i <= pages; i++) {
        pageTemplates[`${i}`] = template;
    }
    return pageTemplates;
}

const CampaignForm = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();
    const [campaignName, setCampaignName] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [pages, setPages] = useState(1);
    const [template, setTemplate] = useState('1x4x4');
    const [year, setYear] = useState(new Date().getFullYear());

    function handleSubmit() {
        //document.getElementById("editCampaignLink").click();
        console.log(campaignName);
        console.log(startDate);
        let pageTemplates = makePageTemplates(pages, template);
        let data = {"campaignName": campaignName,
            "startDate": startDate,
            "endDate": endDate,
            "year": year,
            "pages": pages,
            "pageTemplates": pageTemplates,
            "products": {}
        }
        console.log(pageTemplates);
        authFetch(instance, '/api/insert_campaign', {
            "method": "POST",
            "headers": {"Content-Type": "application/json"},
            "body": JSON.stringify(data),
        }).then(function(res) {
            return res.json();
        }).then(function(returnData) {
            data['campaignId'] = returnData['campaignId']
            console.log(data);
            navigate('/edit_campaign', {state: {campaignId: data['campaignId'], name:`${campaignName}`, year: year, campaignStartDate:startDate, campaignEndDate:endDate, pages:pages, template:template, campaignProducts: {}}})
        }).catch(function(error) {
            alert('There was an error connecting to the database, please refresh the page.');
        });
        //navigate('/edit_campaign', {state: {name:`${campaignName}`, campaignStartDate:startDate, campaignEndDate:endDate, pages:pages, template:template, campaignProducts: []}})}
    }

    return (
        <Container>
            <Row>
                <Col xs={4} className="text-start">
                    <h2>Create New Campaign</h2>
                </Col>
                <hr/>
            </Row>
            <Row>
                <Form onSubmit={(event) => {event.preventDefault();}}>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column xs={2} className="text-start">Campaign Name:</Form.Label>
                        <Col xs={7}>
                            <Form.Control id="campaignName" required={true} onChange={(e) => setCampaignName(e.target.value)} placeholder='Only fill out the name of the campaign, without dates or year'></Form.Control>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column xs={2} className="text-start">Year:</Form.Label>
                        <Col xs={2}>
                            <Form.Control id="year" required={true} onChange={(e) => setYear(e.target.value)} value={year}></Form.Control>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column xs={2} className="text-start">Start Date:</Form.Label>
                        <Col xs={2}>
                            <Form.Control type="date" id="startDate" required={true} onChange={(e) => setStartDate(e.target.value)}></Form.Control>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column xs={2} className="text-start">End Date:</Form.Label>
                        <Col xs={2}>
                            <Form.Control type="date" id="endDate" required={true} onChange={(e) => setEndDate(e.target.value)}></Form.Control>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column xs={2} className="text-start">Pages:</Form.Label>
                        <Col xs={2}>
                            <Form.Select id="pages" onChange={(e) => setPages(e.target.value)}>
                                {[...Array(30)].map((x, i) => <option value={i+1} key={i+1}>{i+1}</option>)}
                            </Form.Select>
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column xs={2} className="text-start">Template:</Form.Label>
                        <Col xs={2}>
                            <Form.Select id="template" onChange={(e) => setTemplate(e.target.value)}>
                                {templateList.map((templateOption) => <option value={templateOption.name} key={templateOption.name}>{templateOption.name==="4x4x4"
                                ? "4x4x4 (Covers)"
                                : templateOption.name}</option>)}
                            </Form.Select>
                        </Col>
                    </Form.Group>
                    <br/>
                    <Col xs={3} className="text-start mb-3">
                        <button
                        onClick={() => handleSubmit()}
                        style={{}}>Submit</button>
                    </Col>
                </Form>
            </Row>
        </Container>
    );
}
 
export default CampaignForm;